import {useEffect, useState} from 'react';
import {BigNumber} from '@ttx/core';
import {WalletNetwork} from '../../contexts/authentication-context/types';
import {useSmartContractContext} from '../../contexts/smart-contract/context';
import {isWeb3Contract} from '../../contexts/smart-contract/utils';

interface JoshSavage {
  mintPrice: string | undefined;
  tokenLimit: string | undefined;
  availableSupply: string | undefined;
}
export const useJoshSavageContract: ({
  network,
  isJoshSavage,
}: {
  network: WalletNetwork;
  isJoshSavage: boolean;
}) => JoshSavage = ({network, isJoshSavage = false}) => {
  const [mintPrice, setMintPrice] = useState<string>();
  const [tokenLimit, setTokenLimit] = useState<string>();
  const [availableSupply, setAvailableSupply] = useState<string>();
  const {joshSavageContract} = useSmartContractContext();
  useEffect(() => {
    (async () => {
      if (network !== 'polygon' || !isJoshSavage) {
        setMintPrice('0');
        setTokenLimit('0');
        setAvailableSupply('0');
      } else {
        const loadedJoshContract = await joshSavageContract(network);

        if (!loadedJoshContract) return;

        if (!isWeb3Contract(loadedJoshContract)) return;

        // catch error when a user is changing networks and contract has not loaded
        const price = BigNumber.from('0');

        const limit = await loadedJoshContract
          .maxSupply()
          .catch((e) => console.error(e));

        const totalSupply = await loadedJoshContract
          .totalSupply()
          .catch((e) => console.error(e));
        if (!price || !limit) return;
        setMintPrice(price.toString());
        setTokenLimit(limit);
        setAvailableSupply((Number(limit) - Number(totalSupply)).toString());
      }
    })();
    return () => {
      setMintPrice(undefined);
    };
  }, [joshSavageContract, network]);

  return {
    mintPrice,
    tokenLimit,
    availableSupply,
  };
};
